export default __webpack_public_path__ + "static/media/github-brands.8bce9409.svg";